import { CoordinatorsList } from 'presentation/app/modules/Professionals/Coordinators/pages';
import React from 'react';

export const MakeCoordinatorsList: React.FC = () => {
  return <CoordinatorsList />;
};
